import { BillingFrequency } from "../offerings/offering"
import { PaymentTransaction } from "../payments/payments"

export enum BillingPeriodStatus {
  PENDING = 'pending',
  PAID = 'paid',
  OVERDUE = 'overdue',
  CANCELLED = 'cancelled',
  PARTIAL = 'partial'
}

export enum SubscriptionStatus {
  PENDING = 'pending',
  ACTIVE = 'active',
  SUSPENDED = 'suspended',
  CANCELLED = 'cancelled',
  EXPIRED = 'expired'
}

export interface SubscriptionPayment {
  subscriptionId: string
  billingPeriodId: string
  paymentId: string
  amount: number
  periodStartDate: Date
  periodEndDate: Date
}

export interface BillingPeriodData {
  id: string
  subscriptionId: string
  periodStartDate: Date
  periodEndDate: Date
  dueDate: Date
  status: BillingPeriodStatus
  totalAmount: number
  outstandingAmount: number
  isPaid: boolean
  billingFrequency: BillingFrequency
}

export interface ModifyBillingPeriodDto {
  totalAmount?: number
  status?: BillingPeriodStatus
  periodStartDate?: Date
  periodEndDate?: Date
  billingPeriodId?: string
}

export interface CreateBillingPeriodDto {
  periodStartDate: string
  periodEndDate?: string
  amount?: number
}

export interface SubscriptionData {
  contractId: string
  offeringCode: string,
  offeringName: string,
  subscriptionId: string
  billingPeriodId: string
  subscriptionAmount: number
  subscriptionStatus: SubscriptionStatus
  subStartDate: Date
  subEndDate: Date
  billingFrequency: BillingFrequency
  periodStatus: BillingPeriodStatus
  periodStartDate: Date
  periodEndDate: Date
  totalAmount: number
  outstandingAmount: number
  payments: PaymentTransaction[]
}

export function formatSubscriptionStatus(status: SubscriptionStatus): string {
  const labels: Record<SubscriptionStatus, string> = {
    [SubscriptionStatus.PENDING]: 'Pendiente',
    [SubscriptionStatus.ACTIVE]: 'Activo',
    [SubscriptionStatus.SUSPENDED]: 'Suspendido',
    [SubscriptionStatus.CANCELLED]: 'Cancelado',
    [SubscriptionStatus.EXPIRED]: 'Vencido',
  }
  return labels[status]
}

export function getSubscriptionStatusVariant(status: SubscriptionStatus): 'default' | 'secondary' | 'destructive' | 'outline' | 'warning' | 'success' | 'primary' {
  const variants: Record<SubscriptionStatus, 'default' | 'secondary' | 'destructive' | 'outline' | 'warning' | 'success' | 'primary'> = {
    [SubscriptionStatus.PENDING]: 'warning',
    [SubscriptionStatus.ACTIVE]: 'success',
    [SubscriptionStatus.SUSPENDED]: 'secondary',
    [SubscriptionStatus.CANCELLED]: 'destructive',
    [SubscriptionStatus.EXPIRED]: 'outline',
  }
  return variants[status]
}

export const isBillingPeriodPending = (period: SubscriptionData) => period.periodStatus === BillingPeriodStatus.PENDING 
|| period.periodStatus === BillingPeriodStatus.OVERDUE